import { PaginaNode, ProgettiNode } from '@gql/graphql'
import {
  CollezioniInfoShowcase,
  GenericHero,
  Carousel,
  ImageWithChips,
  Page,
  Prefooter,
  ProgettiCorrelatiSection,
} from 'components/organisms'
import { useTrans } from 'hooks'
import { Button, WContainer } from '../../atoms'
import styles from './ProgettiDetailTemplate.module.sass'
import { useEffect } from 'react'
import { collezioneToTrack, trackingEcommerceEvent, uniformData } from '@utils/gtm'

interface Props {
  pagina?: PaginaNode
  progetto?: ProgettiNode
}

const ProgettiDetailTemplate = (props: Props) => {
  const { pagina = undefined, progetto = undefined } = props

  const t = useTrans()

  const handleClickTracking = (item, index) => {
    trackingEcommerceEvent('select_item', {
      item_list_id: progetto?.pk,
      item_list_name: uniformData(progetto?.slug) || '',
      items: [collezioneToTrack(item, index, progetto)],
    })
  }

  useEffect(() => {
    trackingEcommerceEvent('view_item_list', {
      item_list_id: progetto?.pk,
      item_list_name: uniformData(progetto?.slug) || '',
      items: progetto.infoProgettiCollezione.map((p, index) => {
        return collezioneToTrack(p.collezione, index, progetto)
      }),
    })
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero
          pagina={{
            titolo: progetto.title,
            descrizione: '',
            breadcrumbs: progetto.breadcrumbs,
          }}
          logo={progetto.premio}
        />
        <div className={styles.container}>
          <ImageWithChips
            item={{
              image: progetto.imageUrl,
              imageAlt: progetto.imageAlt,
            }}
            chips={progetto.destinazioni?.map((x) => x.titolo)}
          />
          <div className={styles.content}>
            {(!!progetto.sottotitolo ||
              !!progetto.description ||
              !!progetto?.infoProgettiCollezione) && (
              <WContainer variant="sm">
                <div className={styles.header}>
                  {(!!progetto.sottotitolo || !!progetto.description) && (
                    <div className={styles.headerContent}>
                      {!!progetto.sottotitolo && (
                        <h3
                          className={styles.title}
                          dangerouslySetInnerHTML={{ __html: progetto.sottotitolo }}
                        />
                      )}
                      {!!progetto.description && (
                        <div
                          className={styles.descriptionHeader}
                          dangerouslySetInnerHTML={{ __html: progetto.description }}
                        />
                      )}
                    </div>
                  )}
                  {!!progetto?.infoProgettiCollezione?.length && (
                    <Button
                      label={t('Scopri le collezioni utilizzate')}
                      size="lg"
                      variant="ghost"
                      className={styles.headerButton}
                      href={'#collections'}
                    />
                  )}
                </div>
              </WContainer>
            )}
            {progetto?.galleryProgettoDetail?.length && (
              <Carousel
                item={{
                  pk: progetto.id,
                  children: progetto.galleryProgettoDetail.map((x) => ({
                    pk: x.id,
                    imageAlt: x.imageAlt,
                    image: x.url,
                  })),
                }}
                className={styles.carousel}
              />
            )}
            {progetto.descriptionFooter && (
              <WContainer variant="sm">
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: progetto?.descriptionFooter }}
                />
              </WContainer>
            )}
          </div>
        </div>

        <CollezioniInfoShowcase
          refId="collections"
          item={progetto.infoProgettiCollezione}
          handleClickTracking={handleClickTracking}
        />
        <ProgettiCorrelatiSection progetti={progetto.correlati} theme="white" />
        <Prefooter />
      </main>
    </Page>
  )
}

export default ProgettiDetailTemplate
